export default () => {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.44493 11.3287L4.60227 7.00175L0.944056 9.32255L0 7.67045L3.8549 5.66434L0 3.65822L0.944056 2.00612L4.60227 4.32692L4.44493 0H6.33304L6.1757 4.32692L9.83392 2.00612L10.778 3.65822L6.92308 5.66434L10.778 7.67045L9.83392 9.32255L6.1757 7.00175L6.33304 11.3287H4.44493Z"
        fill="#B8C7FF"
      />
    </svg>
  )
}
